import { useMatch } from 'react-router-dom'

// Mirrors v5 useRouteMatch behavior: match the leading `/product/subProduct/program?`
// segments and accept any trailing path via the `/*` splat.
const useProductMatchParams = () => {
  return useMatch('/:product/:subProduct?/:program?/*')
}

export default useProductMatchParams
